import { PressureDatum, usePressureData } from '@/api/historicalData';
import { pressureIcon } from '@/assets';
import { Line } from '@/charts';
import { colorsets } from '@/charts/common';
import { SensorLineChartSection } from '@/components/spotter/historicalDataTab/SensorLineChartSection';
import { useDateRangeContext } from '@/context/DateRangeContext';
import { useSpotterContext } from '@/context/SpotterContext';

export const WATER_PRESSURE_LINE: Line<PressureDatum> = {
    id: 'subsurface-pressure',
    label: 'Water pressure',
    valueKey: 'pressure',
    unitKey: 'units',
    unitTypeKey: 'unitType',
    color: colorsets.blue, // placeholder for type; will be replaced per sensor
};

export const WaterPressureSection = () => {
    const { spotterId } = useSpotterContext();
    const { dateRange } = useDateRangeContext();

    const sensorData = usePressureData({
        spotterId: spotterId!,
        dateRange,
    });

    return (
        <SensorLineChartSection
            chartId="water-pressure"
            chartTitle="Water pressure"
            yAxisLabel="Pressure"
            sensorType="pressure"
            sensorData={sensorData}
            baseLine={WATER_PRESSURE_LINE}
            sensorIcon={{
                src: pressureIcon,
            }}
            alertLineId="smartmooring_threshold_water_pressure"
        />
    );
};
